import { View } from 'react-native'

import { VoiceAssessmentEmptyState } from './VoiceAssessmentEmptyState'
import { VoiceAssessmentSectionHeader } from './VoiceAssessmentSectionHeader'

interface VoiceAssessmentLatestAssessmentEmptyCardProps {
  onStartAssessment: () => void
}

export function VoiceAssessmentLatestAssessmentEmptyCard({
  onStartAssessment,
}: VoiceAssessmentLatestAssessmentEmptyCardProps) {
  return (
    <View className="gap-3 rounded-lg bg-background px-4 py-3">
      <VoiceAssessmentSectionHeader />
      <VoiceAssessmentEmptyState
        variant="embedded"
        onStartAssessment={onStartAssessment}
      />
    </View>
  )
}
